import { TodoCategory, TodoSearchFilter, TodoStatus } from "@graphql";

export interface TicketSearchFormData extends TodoSearchFilter {
  assignedTo: string[];
  createdByData: string[];
}

export const ticketSearchFormInitialData: TicketSearchFormData = {
  text: "",
  managedBy: [],
  createdByData: [],
  delegatedBy: [],
  assignedTo: [],
  createdDate: { from: null, to: null },
  dueDate: { from: null, to: null },
  category: [TodoCategory.MyTask],
  tags: [],
  status: [TodoStatus.New, TodoStatus.Accepted, TodoStatus.InProgress],
  priority: null,
  teamIds: []
};
